<template>
	<div class="header_container" >
		<img v-if="!!onPrev" src="/static/icons/arrow/arrow_left.svg" width="24" height="24" @click="handlePrev" />
		<div v-else style="width: 24px" />
		<div v-if="title" class="heading_7">
			{{ title }}
		</div>
		<img v-if="!!onClose" src="/static/icons/close.svg" width="24" height="24" @click="handleClose"
			style="float:right" />
		<img v-else-if="!!isShowHome" src="/static/icons/home.svg" width="24" height="24" @click="handleGoHome"
			style="float:right" />
		<img v-else-if="isShowMenu" src="/static/icons/hamburger.svg" width="24" height="24" @click="toggleMenu"
			style="float:right" />
		<div v-else style="width: 24px" />
		<HamburgerMenu v-if="isShowMenu" :isVisible="isOpenMenu" :onClose="toggleMenu" />
	</div>
</template>

<script>
import HamburgerMenu from './AiHamburgerMenu.vue'

export default {
	data() {
		return {
			isOpenMenu: false
		}
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		onClose: {
			type: Function
		},
		onPrev: {
			type: Function
		},
		returnName: {
			type: String,
			required: false,
		},
		isShowHome: {
			type: Boolean,
			default: false
		},
		isShowMenu: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		handlePrev() {
			if(this.returnName){
				this.$router.push({name:this.returnName});
			} else {
				this.$router.go(-1);
			}
			this.onPrev()
		},
		handleClose() {
			this.onClose()
		},
		handleGoHome() {
			this.$router.push({ name: 'AiMain' })
		},
		toggleMenu() {
			this.isOpenMenu = !this.isOpenMenu
		}
	},
	mounted(){

	},
	components: {
		HamburgerMenu
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ai/AiHeader.vue